export enum FrageAusscheidungshaeufigkeit {
  NEIN = 'nein',

  GELEGENTLICH = 'gelegentlich',

  IMMER = 'immer',
}
